import { Button, ButtonMode, ICONS, Icon } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { FC, useState } from 'react';
import { TextArea } from 'semantic-ui-react';
import styles from './TextareaCounter.module.scss';

export interface TextareaWithCounterProps {
  maxNumber: number;
  onSubmit: (query: string) => void;
  disabled: boolean;
  disabledSubmit: boolean;
}
const cx = classNames.bind(styles);

const TextareaWithCounter: FC<TextareaWithCounterProps> = ({ maxNumber, onSubmit, disabled, disabledSubmit }) => {
  const [text, setText] = useState('');

  const handleTextChange = (event) => {
    const newText = event.target.value;
    if (newText.length <= maxNumber) {
      setText(newText);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      onSubmit(text);
      setText('');
    }
  };

  return (
    <div className={cx('body')}>
      <TextArea
        data-testid="question-textarea"
        value={text}
        placeholder="How can I help?"
        onChange={handleTextChange}
        onKeyPress={handleKeyPress}
        disabled={disabled}
      />
      <Button
        mode={ButtonMode.PRIMARY}
        className={cx('button')}
        onClick={() => {
          onSubmit(text);
          setText('');
        }}
        disabled={disabledSubmit || text.trim() === ''}
      >
        <Icon name={ICONS.ArrowUp} />
      </Button>
    </div>
  );
};

export default TextareaWithCounter;
